/**
 * Environment configuration
 *
 * This file centralizes all environment variables and provides
 * type-safe access to configuration values.
 *
 * Variables must be prefixed with EXPO_PUBLIC_ to be accessible
 * in the React Native runtime.
 */

interface Env {
  supabaseUrl: string;
  supabaseAnonKey: string;
  appEnv: 'development' | 'production';
  isDevelopment: boolean;
  isProduction: boolean;
  sentryDsn: string | undefined;
  // AdMob (optional — only used on mobile)
  admobBannerIdIos: string | undefined;
  admobBannerIdAndroid: string | undefined;
  admobInterstitialIdIos: string | undefined;
  admobInterstitialIdAndroid: string | undefined;
  // RevenueCat (optional — subscription management)
  revenuecatAppleKey: string | undefined;
  revenuecatGoogleKey: string | undefined;
  revenuecatStripeKey: string | undefined;
  // Google AdSense (optional — web ads for free users)
  adsenseClientId: string | undefined;
  adsenseBannerSlot: string | undefined;
}

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;
const appEnv = (process.env.EXPO_PUBLIC_APP_ENV || 'development') as 'development' | 'production';

// Validate required environment variables
if (!supabaseUrl) {
  throw new Error(
    'Missing EXPO_PUBLIC_SUPABASE_URL environment variable. ' +
    'Please check your .env file or EAS build configuration.'
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    'Missing EXPO_PUBLIC_SUPABASE_ANON_KEY environment variable. ' +
    'Please check your .env file or EAS build configuration.'
  );
}

const env: Env = {
  supabaseUrl,
  supabaseAnonKey,
  appEnv,
  isDevelopment: appEnv !== 'production',
  isProduction: appEnv === 'production',
  sentryDsn: process.env.EXPO_PUBLIC_SENTRY_DSN,
  admobBannerIdIos: process.env.EXPO_PUBLIC_ADMOB_BANNER_ID_IOS,
  admobBannerIdAndroid: process.env.EXPO_PUBLIC_ADMOB_BANNER_ID_ANDROID,
  admobInterstitialIdIos: process.env.EXPO_PUBLIC_ADMOB_INTERSTITIAL_ID_IOS,
  admobInterstitialIdAndroid: process.env.EXPO_PUBLIC_ADMOB_INTERSTITIAL_ID_ANDROID,
  revenuecatAppleKey: process.env.EXPO_PUBLIC_RC_APPLE_KEY,
  revenuecatGoogleKey: process.env.EXPO_PUBLIC_RC_GOOGLE_KEY,
  revenuecatStripeKey: process.env.EXPO_PUBLIC_RC_STRIPE_KEY,
  adsenseClientId: process.env.EXPO_PUBLIC_ADSENSE_CLIENT_ID,
  adsenseBannerSlot: process.env.EXPO_PUBLIC_ADSENSE_SLOT_BANNER,
};

export default env;
